/**
 * Error originating from a server-rendered `type: 'error'` chunk in the AI chat stream.
 * The `message` is already a user-facing string (e.g. a FastAPI `detail`), so the UI
 * should display it as-is instead of wrapping it in a generic error prefix.
 */
export class ChatStreamError extends Error {
    readonly statusCode?: number;

    readonly isServerStreamError = true;

    constructor(message: string, statusCode?: number) {
        super(message);
        this.name = 'ChatStreamError';
        this.statusCode = statusCode;
    }
}
